export default __webpack_public_path__ + "static/media/motorcycle-dealer3.21194bb9.png";